// extracted by mini-css-extract-plugin
export default {"page-owner-messenger-share-button":"klwEm"};